import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../assets/logo.jpg'

export default function Footer() {
  return (
    <footer style={{background:'var(--navy)'}}>
      <div className="max-w-7xl mx-auto px-6 pt-14 pb-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">

        {/* Brand */}
        <div>
          <Link to="/" className="flex items-center gap-3 mb-5">
            <div className="w-11 h-11 rounded-xl overflow-hidden flex-shrink-0">
              <img src={logo} alt="Logo" className="w-full h-full object-cover"/>
            </div>
            <div>
              <div className="font-bold text-sm text-white" style={{fontFamily:'Playfair Display,serif'}}>Sewa Bharti</div>
              <div className="text-[10px] tracking-widest uppercase" style={{color:'rgba(255,255,255,0.35)'}}>Haryana Pradesh</div>
            </div>
          </Link>
          <p className="text-sm leading-relaxed" style={{color:'rgba(255,255,255,0.4)'}}>
            A non-profit organization working for the welfare of the people of Haryana, India since 1980 — serving all without discrimination.
          </p>
          {/* Social links */}
          <div className="flex items-center gap-3 mt-5">
            <a href="https://www.facebook.com/share/16AYhcvdp6/" target="_blank" rel="noopener noreferrer"
              className="w-8 h-8 rounded-lg flex items-center justify-center transition-all hover:-translate-y-0.5"
              style={{background:'rgba(255,255,255,0.07)'}}>
              <svg className="w-4 h-4" fill="rgba(255,255,255,0.5)" viewBox="0 0 24 24"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>
            </a>
            <a href="https://youtu.be/vplUv0K9AJs" target="_blank" rel="noopener noreferrer"
              className="w-8 h-8 rounded-lg flex items-center justify-center transition-all hover:-translate-y-0.5"
              style={{background:'rgba(255,255,255,0.07)'}}>
              <svg className="w-4 h-4" fill="rgba(255,255,255,0.5)" viewBox="0 0 24 24"><path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 001.46 6.42 29 29 0 001 12a29 29 0 00.46 5.58A2.78 2.78 0 003.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.4a2.78 2.78 0 001.95-1.95A29 29 0 0023 12a29 29 0 00-.46-5.58zM9.75 15.02V8.98L15.5 12l-5.75 3.02z"/></svg>
            </a>
          </div>
          <div className="flex items-center gap-1.5 mt-4 text-xs" style={{color:'rgba(255,255,255,0.22)'}}>
            Made with <svg className="w-3 h-3" fill="var(--saffron)" viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg> for the community
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-xs font-semibold tracking-widest uppercase mb-5 flex items-center gap-2 text-white">
            <span className="w-5 h-0.5 rounded" style={{background:'var(--saffron)'}}/>Quick Links
          </h4>
          <ul className="space-y-3">
            {[
              { label:'Home', to:'/' },
              { label:'About Us', to:'/about' },
              { label:'Prant Karyakarini', to:'https://www.sewabhartiharyana.org/wp-content/uploads/2025/04/PRANT-KARYAKARINI-2024-2025.pdf', ext:true },
              { label:'Campaign', to:'/campaign' },
              { label:'Get Involved', to:'/get-involved' },
              { label:'Contact Us', to:'/contact' },
              { label:'Donate', to:'/donate' },
            ].map(({ label, to, ext }) => (
              <li key={label}>
                {ext
                  ? <a href={to} target="_blank" rel="noopener noreferrer" className="text-sm flex items-center gap-2 transition-colors" style={{color:'rgba(255,255,255,0.4)'}}>
                      <span className="w-1 h-1 rounded-full" style={{background:'rgba(232,103,10,0.5)'}}/>
                      {label}
                    </a>
                  : <Link to={to} className="text-sm flex items-center gap-2 transition-colors" style={{color:'rgba(255,255,255,0.4)'}}>
                      <span className="w-1 h-1 rounded-full" style={{background:'rgba(232,103,10,0.5)'}}/>
                      {label}
                    </Link>
                }
              </li>
            ))}
          </ul>
        </div>

        {/* Explore */}
        <div>
          <h4 className="text-xs font-semibold tracking-widest uppercase mb-5 flex items-center gap-2 text-white">
            <span className="w-5 h-0.5 rounded" style={{background:'var(--saffron)'}}/>Explore
          </h4>
          <ul className="space-y-3">
            {[
              { label:'Our Initiatives', to:'/initiatives' },
              { label:'Media', to:'/media' },
              { label:'Photo Gallery', to:'/events' },
              { label:'Videos', to:'/videos' },
              { label:'Education', to:'/service/sewa-bharti-haryana-pardesh-education' },
              { label:'Health', to:'/service/sewa-bharti-haryana-pardesh-health' },
              { label:'Self-Reliance', to:'/service/sewa-bharti-haryana-pardesh-self-reliance' },
            ].map(({ label, to }) => (
              <li key={label}>
                <Link to={to} className="text-sm flex items-center gap-2 transition-colors" style={{color:'rgba(255,255,255,0.4)'}}>
                  <span className="w-1 h-1 rounded-full" style={{background:'rgba(232,103,10,0.5)'}}/>
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-xs font-semibold tracking-widest uppercase mb-5 flex items-center gap-2 text-white">
            <span className="w-5 h-0.5 rounded" style={{background:'var(--saffron)'}}/>Contact Us
          </h4>
          <div className="space-y-4">
            {[
              { icon:'M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z M12 7a3 3 0 100 6 3 3 0 000-6z', text:'Sewa Shree Aashram, Valmiki Basti, Arjun Gate, Karnal-132001, Haryana' },
              { icon:'M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8 19.79 19.79 0 012 2.21 2 2 0 014 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z', text:'0184-2255874' },
              { icon:'M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z M22 6l-10 7L2 6', text:'sewabharti1980@gmail.com' },
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5" style={{background:'rgba(232,103,10,0.15)'}}>
                  <svg className="w-3.5 h-3.5" fill="none" stroke="var(--saffron-light)" strokeWidth="2" viewBox="0 0 24 24"><path d={item.icon}/></svg>
                </div>
                <p className="text-sm leading-relaxed" style={{color:'rgba(255,255,255,0.4)'}}>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="px-6 py-4" style={{borderTop:'1px solid rgba(255,255,255,0.06)'}}>
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-2 text-xs" style={{color:'rgba(255,255,255,0.22)'}}>
          <span>© 2025 Sewa Bharti Haryana Pradesh. All Rights Reserved.</span>
          <span>Serving humanity since 1980</span>
        </div>
      </div>
    </footer>
  )
}
